import OrderExternalIdUpdateRequest, {
  OrderExternalIdUpdateRequestBody,
} from "./order-external-id-update-request";

const createBody = (
  request: OrderExternalIdUpdateRequest,
): OrderExternalIdUpdateRequestBody => {
  return {
    newExternalId: request.newExternalId,
  };
};

const orderExternalIdUpdateRequestFactory = { createBody };

export default orderExternalIdUpdateRequestFactory;
